import lodash from 'lodash';
import { ModelIdSymbol } from './constants.js';
const { omitBy } = lodash;
export const omitUndefined = (obj) => omitBy(obj, (value) => value === undefined);
export const createIsInstance = (clazz) => {
    function isInstance(instance) {
        if (!instance?.constructor || Object.hasOwn(instance, 'constructor')) {
            return false;
        }
        if (Function.prototype[Symbol.hasInstance].call(this.constructor, instance)) {
            return true;
        }
        const considerInstance = this.name === clazz.name || this.name === instance.constructor.name;
        return considerInstance && instance.constructor[ModelIdSymbol] === this[ModelIdSymbol];
    }
    return isInstance;
};
